import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Container, CssBaseline, makeStyles, Snackbar } from '@material-ui/core'

import { Routes } from './routes'
import { Header } from './components/header'
import { Footer } from './components/footer'
import { WhatsAppChatDialog } from './components/whatsapp-chat'
import { WhatsAppFab } from './components/whatsapp-fab'
import { SnackbarContentWrapper } from './components/snackbar'
import { context } from './store/context'
import { setMessage, startupStart } from './store/actions'
import { useSelectors, useSideEffects } from './store/hooks'

import { styles } from './styles'

// Once per module: makeStyles called inside a render built a new JSS sheet,
// with new class names, on every render (booking screen, 11 Oct 2026).
const useStyles = makeStyles(styles)

export const App = React.memo(() => {
  const classes = useStyles()
  const { dispatch } = useContext(context)
  const [open, setOpen] = useState(false)
  const { message, messageTimeout, messagePosition, messageColor } = useSelectors()

  const handleClose = useCallback(
    (event, reason) => {
      if (reason === 'clickaway') {
        return
      }

      dispatch(setMessage(null))
      setOpen(false)
    },
    [dispatch]
  )

  useSideEffects()

  useEffect(() => {
    dispatch(startupStart())
  }, [dispatch])

  useEffect(() => {
    if (!message) return

    setOpen(true)
  }, [message, setOpen])

  return (
    <>
      <CssBaseline />
      <div className={classes.root}>
        <Header />
        <Container classes={{ root: classes.container }} component="main" maxWidth={false}>
          <Routes />
        </Container>
        <Footer />
        <WhatsAppChatDialog />
        <WhatsAppFab />
      </div>
      <Snackbar
        anchorOrigin={{
          vertical: messagePosition || 'bottom',
          horizontal: 'center'
        }}
        open={open}
        autoHideDuration={messageTimeout}
        onClose={handleClose}>
        <SnackbarContentWrapper onClose={handleClose} message={message} style={messageColor ? { backgroundColor: messageColor } : null} />
      </Snackbar>
    </>
  )
})
